import React, { useEffect, useRef, useState } from "react";

const FUNC_KEYS = "F1F2F3F4F5F6F7F8F9F10F11F12";

function getValue(value: number, isInteger: boolean): string {
  if (isNaN(value)) {
    return value.toString();
  } else {
    if (isInteger) {
      return value.toString();
    } else {
      return value.toFixed(2);
    }
  }
}

type DefaultImagingSettingTextBoxProps = {
  name: string;
  label: string;
  value: number;
  unit: string;
  min: number;
  max: number;
  onChange: (name: string, value: number) => void;
  style?: React.CSSProperties;
  disabled: boolean;
  isInteger: boolean;
  onErrorOccur: (key: string) => void;
  onErrorCleared: (key: string) => void;
};

export default function DefaultImagingSettingTextBox({
  name,
  label,
  value,
  unit,
  min,
  max,
  onChange,
  style = {},
  disabled,
  isInteger,
  onErrorOccur,
  onErrorCleared,
}: DefaultImagingSettingTextBoxProps) {
  const [isError, setIsError] = useState(false);
  const [tbValue, setTbValue] = useState(getValue(value, isInteger));
  const inputTextRef = useRef<HTMLInputElement>(null);

  const labelUnit = unit === "" ? label : label + " (" + unit + ")";

  useEffect(() => {
    setTbValue(getValue(value, isInteger));
    if (value <= max && value >= min || disabled) {
      setIsError(false);
      onErrorCleared(name);
      return;
    }else{
      setIsError(true);
    }
  }, [value, isInteger, max, min, name, onErrorCleared, disabled]);

  const onBlur = (value: string): void => {
    let numberValue = parseFloat(value);
    if (isNaN(numberValue)) {
      setIsError(true);
      onErrorOccur(name);
      return;
    }

    if (numberValue > max || numberValue < min) {
      setIsError(true);
      onErrorOccur(name);
      onChange(name, numberValue);
      return;
    }

    setIsError(false);
    onErrorCleared(name);
    // if (isInteger) {
    //   e.target.value = Math.round(numberValue);
    // } else {
    //   e.target.value = numberValue;
    // }

    onChange(name, numberValue);
  };

  const onKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const selectionStart = inputTextRef.current?.selectionStart ?? 0;
    const selectionEnd = inputTextRef.current?.selectionStart ?? 0;
    const oldText = inputTextRef.current?.value ?? "";
    const fullText = oldText.slice(0, selectionStart) + e.key + oldText.slice(selectionStart, selectionEnd);
    if (
      !FUNC_KEYS.includes(e.key) &&
      e.key !== "ArrowLeft" &&
      e.key !== "ArrowRight" &&
      e.key !== "Backspace" &&
      e.key !== "Escape" &&
      e.key !== "Enter" &&
      e.key !== "Delete" &&
      e.key !== "Tab" &&
      e.key !== "Home" &&
      e.key !== "End" &&
      e.ctrlKey !== true &&
      !fullText.match(/^[-]?\d*\.?\d*$/)
    )
      e.preventDefault();

    if (e.key === "Enter") {
      inputTextRef.current?.blur();
    }
  };

  return (
    <div
      style={{
        backgroundColor: "transparent",
        color: disabled ? "#808080" : "#000000",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        ...style,
      }}
    >
      <div
        style={{
          width: "125px",
          fontSize: "13px",
          lineHeight: "16px",
          textAlign: "left",
        }}
      >
        {labelUnit}
      </div>
      <input
        type="text"
        style={{
          width: "65px",
          height: "30Px",
          paddingLeft: "5px",
          background: isError ? "#E9787E" : disabled ? "rgba(204, 204, 204, 0.1)" : "#FFFFFF",
          color: disabled ? "#808080" : "#000000",
          border: disabled ? "1px solid rgba(133, 133, 133, 0.3)" : "1px solid rgba(133, 133, 133, 1)",
          padding: "1px 2px",
        }}
        name={name}
        value={tbValue}
        onChange={(e) => setTbValue(e.target.value)}
        onBlur={(e) => onBlur(e.target.value)}
        disabled={disabled}
        onKeyPress={onKeyPress}
        ref={inputTextRef}
      />
    </div>
  );
}
